import React from 'react'
import { useSelector } from '~/store/hooks'

import { useStaticQuery, graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'

import transformLink from '~/utils/transformLink'
import encodeHtml from '~/utils/encodeHtml'

import trads from '~/intl/trads.json'
import GetNewsroomUrls from '~/utils/getNewsroomUrls'

const Breadcrumb = ({
  links,
  current,
  currentUrl,
  type = null,
  withProfileNav,
  customType = null,
}) => {
  const lang = useSelector((state) => state.lang)
  const newsroomUrls = GetNewsroomUrls()

  const metadata = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          baseUrl
        }
      }
    }
  `)

  const baseUrl = metadata.site.siteMetadata.baseUrl.slice(0, -1)

  const helmetDatas = []
  let currentIndex = 2

  if (links !== null && links !== undefined) {
    currentIndex = links.length + 2

    links.forEach((link, i) => {
      link = link.fields ? link.fields : link
      const url = transformLink(link, true, false).url

      const helmetObject = {
        '@type': 'ListItem',
        position: i + 2,
        name: encodeHtml(link.label),
        item: `${baseUrl}${url}`,
      }
      helmetDatas.push(JSON.stringify(helmetObject))
    })
  }

  const renderStaticBreadcrumb = (type) => {
    switch (type) {
      case 'event':
        currentIndex = 4

        helmetDatas.push(`{
          "@type": "ListItem",
          "position":  2,
          "name": "Newsroom",
          "item": "${baseUrl}${`/${newsroomUrls['Hub'][lang]}`}"
        }, {
          "@type": "ListItem",
          "position":  3,
          "name": "${trads?.[lang]?.lab?.titleContentTypes?.event}",
          "item": "${baseUrl}${`/${newsroomUrls['Événements'][lang]}`}"
        }`)

        return (
          <>
            <span className="breadcrumb__item">
              <Link
                to={`/${newsroomUrls['Hub'][lang]}`}
                title="Newsroom"
                className="breadcrumb__link"
              >
                <span className="breadcrumb__name">Newsroom</span>
              </Link>
            </span>
            <span className="breadcrumb__item">
              <Link
                onClick={() => sessionStorage.setItem('currentUrl', null)}
                to={`/${newsroomUrls['Événements'][lang]}`}
                title={trads?.[lang]?.lab?.titleContentTypes?.event}
                className="breadcrumb__link"
              >
                <span className="breadcrumb__name">
                  {trads?.[lang]?.lab?.titleContentTypes?.event}
                </span>
              </Link>
            </span>
          </>
        )
      case 'newsroom':
        currentIndex = 3

        helmetDatas.push(`{
          "@type": "ListItem",
          "position":  2,
          "name": "Newsroom",
          "item": "${baseUrl}${`/${newsroomUrls['Hub'][lang]}`}"
        }`)

        return (
          <span className="breadcrumb__item">
            <Link
              to={`/${newsroomUrls['Hub'][lang]}`}
              title="Newsroom"
              className="breadcrumb__link"
            >
              <span className="breadcrumb__name">Newsroom</span>
            </Link>
          </span>
        )
      case 'action':
        currentIndex = 4

        helmetDatas.push(`{
          "@type": "ListItem",
          "position":  2,
          "name": "Newsroom",
          "item": "${baseUrl}${`/${newsroomUrls['Hub'][lang]}`}"
        }, {
          "@type": "ListItem",
          "position":  3,
          "name": "${trads?.[lang]?.lab?.titleContentTypes?.actions}",
          "item": "${baseUrl}${`/${newsroomUrls['Actions'][lang]}`}"
        }`)

        return (
          <>
            <span className="breadcrumb__item">
              <Link
                to={`/${newsroomUrls['Hub'][lang]}`}
                title="Newsroom"
                className="breadcrumb__link"
              >
                <span className="breadcrumb__name">Newsroom</span>
              </Link>
            </span>
            <span className="breadcrumb__item">
              <Link
                onClick={() => sessionStorage.setItem('currentUrl', null)}
                to={`/${newsroomUrls['Actions'][lang]}`}
                title={trads?.[lang]?.lab?.titleContentTypes?.actions}
                className="breadcrumb__link"
              >
                <span className="breadcrumb__name">
                  {trads?.[lang]?.lab?.titleContentTypes?.actions}
                </span>
              </Link>
            </span>
          </>
        )
      case 'news':
        currentIndex = 4

        helmetDatas.push(`{
          "@type": "ListItem",
          "position":  2,
          "name": "Newsroom",
          "item": "${baseUrl}${`/${newsroomUrls['Hub'][lang]}`}"
        }, {
          "@type": "ListItem",
          "position":  3,
          "name": "${trads?.[lang]?.lab?.titleContentTypes?.news}",
          "item": "${baseUrl}${`/${newsroomUrls['Actualités'][lang]}`}"
        }`)

        return (
          <>
            <span className="breadcrumb__item">
              <Link
                to={`/${newsroomUrls['Hub'][lang]}`}
                title="Newsroom"
                className="breadcrumb__link"
              >
                <span className="breadcrumb__name">Newsroom</span>
              </Link>
            </span>
            <span className="breadcrumb__item">
              <Link
                onClick={() => sessionStorage.setItem('currentUrl', null)}
                to={`/${newsroomUrls['Actualités'][lang]}`}
                title={trads?.[lang]?.lab?.titleContentTypes?.news}
                className="breadcrumb__link"
              >
                <span className="breadcrumb__name">
                  {trads?.[lang]?.lab?.titleContentTypes?.news}
                </span>
              </Link>
            </span>
          </>
        )
      case 'labo':
        currentIndex = 3

        helmetDatas.push(`{
          "@type": "ListItem",
          "position":  2,
          "name": "${trads?.[lang].lab?.breadcrumb}",
          "item": "${baseUrl}${lang === 'fr' ? '/recherche' : '/en/search'}"
        }`)

        return (
          <span className="breadcrumb__item">
            <Link
              to={lang === 'fr' ? '/labo' : '/en/lab'}
              state={{ filters: ['labo'] }}
              title={trads?.[lang]?.lab?.breadcrumb}
              className="breadcrumb__link"
            >
              <span className="breadcrumb__name">
                {trads?.[lang]?.lab?.breadcrumb}
              </span>
            </Link>
          </span>
        )
      case 'page':
        let tradKey = null

        if (customType !== null) {
          currentIndex = 4
          tradKey = customType === 'Médiathèque' ? 'medias' : 'blog'

          helmetDatas.push(`{
            "@type": "ListItem",
            "position":  2,
            "name": "Newsroom",
            "item": "${baseUrl}${`/${newsroomUrls['Hub'][lang]}`}"
          }, {
            "@type": "ListItem",
            "position":  3,
            "name": "${trads?.[lang]?.newsroom?.stats[tradKey].plural}",
            "item": "${baseUrl}${`/${newsroomUrls[customType][lang]}`}"
          }`)
        }

        return (
          <>
            {customType !== null && (
              <>
                <span className="breadcrumb__item">
                  <Link
                    to={`/${newsroomUrls['Hub'][lang]}`}
                    title="Newsroom"
                    className="breadcrumb__link"
                  >
                    <span className="breadcrumb__name">Newsroom</span>
                  </Link>
                </span>
                <span className="breadcrumb__item">
                  <Link
                    to={`/${newsroomUrls[customType][lang]}`}
                    title={trads?.[lang]?.newsroom?.stats[tradKey].plural}
                    className="breadcrumb__link"
                  >
                    <span className="breadcrumb__name">
                      {trads?.[lang]?.newsroom?.stats[tradKey].plural}
                    </span>
                  </Link>
                </span>
              </>
            )}
          </>
        )
      case 'simulator':
        return null
      default:
        return 'error'
    }
  }

  return (
    <>
      <nav
        className={`breadcrumb ${withProfileNav ? 'breadcrumb--profile' : ''}`}
      >
        <span className="breadcrumb__item">
          <Link
            to={lang === 'fr' ? '/' : '/en'}
            title={trads?.[lang]?.breadcrumb}
            className="breadcrumb__link"
          >
            <span className="breadcrumb__name">
              {trads?.[lang]?.breadcrumb}
            </span>
          </Link>
        </span>
        {type !== null &&
          (links === null || links === undefined) &&
          renderStaticBreadcrumb(type)}
        {links !== null &&
          links !== undefined &&
          links.map((item, i) => {
            let link = item.fields ? item.fields : item
            const { url, contentTypeContentful } = transformLink(
              link,
              true,
              false,
              newsroomUrls,
            )

            return (
              <span className="breadcrumb__item" key={i}>
                {contentTypeContentful === 'ContentfulSimulator' ||
                contentTypeContentful === 'ContentfulContact' ? (
                  <a href={url} title={link.label} className="breadcrumb__link">
                    <span className="breadcrumb__name">{link.label}</span>
                  </a>
                ) : (
                  <Link
                    to={url}
                    title={link.label}
                    className="breadcrumb__link"
                  >
                    <span className="breadcrumb__name">{link.label}</span>
                  </Link>
                )}
              </span>
            )
          })}
        <span className="breadcrumb__item">
          <span className="breadcrumb__name">{current}</span>
        </span>
      </nav>

      <Helmet>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "${baseUrl}${lang === 'fr' ? '/' : '/en'}"
            }, ${helmetDatas.length !== 0 ? `${helmetDatas},` : ''}
            {
              "@type": "ListItem",
              "position": ${currentIndex},
              "name": "${encodeHtml(current)}",
              "item": "${baseUrl}${currentUrl}"
            }]
          }
        `}</script>
      </Helmet>
    </>
  )
}

export default Breadcrumb
